import React from 'react';
import cx from 'classnames';
import styles from './Modal.module.scss';

function ModalContent(props) {
  const { className, children, ...rest } = props;
  return (
    <main className={cx(styles.modalContent, className)} {...rest}>
      {children}
    </main>
  );
}

export default ModalContent;
